export const banner = {
  cover: 'https://img.alicdn.com/tfs/TB1XEH7iSf2gK0jSZFPXXXsopXa-9600-3155.png',
  mcover: 'https://gw.alicdn.com/tfs/TB1XEH7iSf2gK0jSZFPXXXsopXa-9600-3155.png',
  alipay: {
    url: 'https://img.alicdn.com/tfs/TB1zvJCiy_1gK0jSZFqXXcpaXXa-228-82.png',
    text: '支付宝',
  },
  brush: {
    url: 'https://img.alicdn.com/tfs/TB11TtDixv1gK0jSZFFXXb0sXXa-384-68.png',
    text: '刷脸就医',
  },
  contact: {
    url: 'https://img.alicdn.com/tfs/TB171NGirj1gK0jSZFOXXc7GpXa-440-102.png',
    text: '马上联系',
  },
  title: '诊前、诊中、诊后刷脸全流程就医',
  content: [
    {
      text:
        '基于蚂蚁金服金融级人脸识别能力，同时与公安部实名库进行对接，可对全量人群进行身份核实。',
    },
    {
      text:
        '通过刷脸就医与患者的具体就诊环节深度整合，实现诊前、诊中、诊后的无障碍全流程刷脸便捷就医。',
    },
  ],
  mobileContent: [
    {
      text: '基于支付宝金融级人脸识别能力，实现全量人口的身份识别。',
    },
  ],
};

export const productData = {
  title: '产品功能',
  moduleData: [
    {
      title: '刷脸就医',
      imgUrl:
        'https://img.alicdn.com/tfs/TB1pgmrirY1gK0jSZTEXXXDQVXa-446-446.png',
    },
    {
      title: '身份识别',
      imgUrl:
        'https://img.alicdn.com/tfs/TB1OvKriAT2gK0jSZFkXXcIQFXa-446-446.png',
    },
    {
      title: '刷脸建档',
      imgUrl:
        'https://img.alicdn.com/tfs/TB1D4CqiBr0gK0jSZFnXXbRRXXa-446-446.png',
    },
    {
      title: '门诊挂号',
      imgUrl:
        'https://img.alicdn.com/tfs/TB1riqlipT7gK0jSZFpXXaTkpXa-446-446.png',
    },
    {
      title: '医技/床位预约',
      imgUrl:
        'https://img.alicdn.com/tfs/TB1TwqrixD1gK0jSZFyXXciOVXa-446-446.png',
    },
    {
      title: '就诊签到',
      imgUrl:
        'https://img.alicdn.com/tfs/TB1YririEY1gK0jSZFCXXcwqXXa-446-446.png',
    },
    {
      title: '刷脸缴费',
      imgUrl:
        'https://img.alicdn.com/tfs/TB1eruniAP2gK0jSZPxXXacQpXa-446-446.png',
    },
    {
      title: '刷脸核身',
      imgUrl:
        'https://img.alicdn.com/tfs/TB19L5riAT2gK0jSZFkXXcIQFXa-446-446.png',
    },
  ],
};

export const advantage = {
  title: '产品优势',
  bgImg: 'https://img.alicdn.com/tfs/TB1tGysiCf2gK0jSZFPXXXsopXa-3840-2036.png',
  moduleData: [
    {
      img: 'https://img.alicdn.com/tfs/TB15gGwiBr0gK0jSZFnXXbRRXXa-196-196.png',
      title: '人脸识别免费使用',
      text:
        '刷脸屏自带阿里定制人脸识别摄像头，可免费提供人脸识别、活体检测、静默识别等一系列能力，而不产生额外的费用支出。',
    },
    {
      img: 'https://img.alicdn.com/tfs/TB1v3utixn1gK0jSZKPXXXvUXXa-182-172.png',
      title: '多种终端规格',
      text:
        '刷脸屏通过阿里服务平台，可提供免费的人脸识别服务，医院和应用系统可通过各种方式方法使用人脸识别服务而不需要额外的费用支出。',
    },
    {
      img: 'https://img.alicdn.com/tfs/TB172qsiEY1gK0jSZFMXXaWcVXa-210-182.png',
      title: '完善技术服务',
      text:
        '提供完善的技术支持服务，可针对医院需求做一定程度的定制化改造。产品具有健全的运营运维机制，可远程实时对设备进行监控、更新、还原。',
    },
    {
      img: 'https://img.alicdn.com/tfs/TB18zStiCf2gK0jSZFPXXXsopXa-178-210.png',
      title: '快速实施部署',
      text:
        '刷脸屏设备自带4G网络模块，无需专门网络走线，接通电源即可使用。同时预装了相关APP应用，仅需少量对接工作即可快速投入使用。',
    },
  ],
  mobileModuleData: [
    {
      img: 'https://img.alicdn.com/tfs/TB15gGwiBr0gK0jSZFnXXbRRXXa-196-196.png',
      title: '人脸识别免费使用',
      text:
        '刷脸屏可免费提供人脸识别、活体检测、静默识别等一系列能力，而不产生额外的费用支出。',
    },
    {
      img: 'https://img.alicdn.com/tfs/TB1v3utixn1gK0jSZKPXXXvUXXa-182-172.png',
      title: '多种终端规格',
      text: '刷脸屏提供多种终端规格，可适用于诊间、窗口、大厅等多种场景。',
    },
    {
      img: 'https://img.alicdn.com/tfs/TB172qsiEY1gK0jSZFMXXaWcVXa-210-182.png',
      title: '完善技术服务',
      text:
        '提供完善的技术支持服务，支持定制化改造。健全的运营运维机制，可远程实时维护升级。',
    },
    {
      img: 'https://img.alicdn.com/tfs/TB18zStiCf2gK0jSZFPXXXsopXa-178-210.png',
      title: '快速实施部署',
      text:
        '刷脸屏设备自带4G网络模块，即插即用。同时预装了相关APP应用，实现快速实施部署。',
    },
  ],
};

export const identity = {
  title: '基于蚂蚁金服金融级人脸识别能力',
  bgImg: 'https://img.alicdn.com/tfs/TB1XxUBjBv0gK0jSZKbXXbK2FXa-3838-2036.png',
  moduleData: [
    {
      img: 'https://img.alicdn.com/tfs/TB1Cwm0irj1gK0jSZFuXXcrHpXa-710-576.png',
      mImg: 'https://gw.alicdn.com/tfs/TB1Cwm0irj1gK0jSZFuXXcrHpXa-710-576.png',
      title: '智能产品运营平台',
      text: '可实现刷脸屏参数智能下发、异常行为智能分析、机型智能适配',
    },
    {
      img: 'https://img.alicdn.com/tfs/TB1wGSWiET1gK0jSZFrXXcNCXXa-708-574.png',
      mImg: 'https://gw.alicdn.com/tfs/TB1wGSWiET1gK0jSZFrXXcNCXXa-708-574.png',
      title: '动态安全风控平台',
      text: '支持设备冷冻策略/可用性策略/防攻击策略',
    },
    {
      img: 'https://img.alicdn.com/tfs/TB1AHGViuL2gK0jSZPhXXahvXXa-708-574.png',
      mImg: 'https://gw.alicdn.com/tfs/TB1AHGViuL2gK0jSZPhXXahvXXa-708-574.png',
      title: '金融级准确率',
      text: '刷脸识别99.99%准确率，十万分之一到百万分之一误识率',
    },
    {
      img: 'https://img.alicdn.com/tfs/TB1ifGYiuH2gK0jSZFEXXcqMpXa-708-574.png',
      mImg: 'https://gw.alicdn.com/tfs/TB1ifGYiuH2gK0jSZFEXXcqMpXa-708-574.png',
      title: '金融级安全性',
      text: '99.9%攻击检测。抵抗照片视频软件建模等攻击',
    },
  ],
};

export const caseData = {
  title: '客户案例',
  bgImg: 'https://img.alicdn.com/tfs/TB1CJEAjy_1gK0jSZFqXXcpaXXa-3838-2110.png',
  moduleData: [
    {
      img: 'https://img.alicdn.com/tfs/TB1B.eZiCf2gK0jSZFPXXXsopXa-774-566.png',
      title: '浙二',
    },
    {
      img: 'https://img.alicdn.com/tfs/TB1aRS0iy_1gK0jSZFqXXcpaXXa-774-566.png',
      title: '重庆',
    },
    {
      img: 'https://img.alicdn.com/tfs/TB1OX90irr1gK0jSZR0XXbP8XXa-774-566.png',
      title: '肿瘤',
    },
    {
      img: 'https://img.alicdn.com/tfs/TB1DKS3iEY1gK0jSZFCXXcwqXXa-774-566.png',
      title: '建德',
    },
  ],
  content: [
    {
      text:
        '目前扁鹊“刷脸就医”全程流在浙江、湖北、广东、江西、陕西、天津、重庆等多地进行了应用，覆盖了全国各类各级医疗机构。同时与各地卫建委开展了深入合作，实现全域刷脸全流程改造，推动区域内“互联网+医疗健康”进程。',
    },
    {
      text:
        '合作医院包括了浙江大学附属第二医院、中国科学院大学附属肿瘤医院、重庆市妇产科医院等数十家医疗机构，同时与浙江省卫健委、陕西省卫健委、郑州市卫健委等多家卫生主管部门开展深入合作，助力区域内智慧医疗水平的提升。',
    },
  ],
};
